module.exports = __webpack_public_path__ + "img/active-9.30f5e5e6.svg";